const resources = {
    forYou: 'For You'
};

export default function getResource(label) {
    return resources[label];
}
